import axios from "axios";
import { Dispatch, useEffect } from "react";
import { Setting } from "../App";
import { CUSTOMER_API_URL } from "../constants";
import {
  createShippingAddress,
  ShippingAddressViewType,
} from "../types/view/shipping-address-view-type";
import { SubscriptionsApiType } from "../types/api/subscriptions-api-type";

export const useShippingAddress = (
  setting: Setting,
  setSubscriptionContractId: Dispatch<string>,
  setShippingAddress: Dispatch<ShippingAddressViewType>
) => {
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = (response.data as SubscriptionsApiType).filter(
          (subscription) => subscription.status === "ACTIVE" || subscription.status === "PAUSED"
        );
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0];
        setSubscriptionContractId(subscription.subscriptionContractId);
        setShippingAddress(await createShippingAddress(subscription));
      } catch (e) {
        console.log(e);
      }
    })();
  }, [setShippingAddress, setSubscriptionContractId, setting.token]);

  const updateShippingAddress = (
    subscriptionContractId: string,
    shippingAddress: ShippingAddressViewType,
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=updateDeliveryAddress`,
          {
            subscriptionId: subscriptionContractId,
            deliveryAddress1: shippingAddress.address1,
            deliveryAddress2: shippingAddress.address2,
            deliveryCity: shippingAddress.city,
            deliveryCompany: shippingAddress.company,
            deliveryCountryCode: shippingAddress.countryCode,
            deliveryFirstName: shippingAddress.firstName,
            deliveryLastName: shippingAddress.lastName,
            deliveryPhone: shippingAddress.phone,
            deliveryProvinceCode: shippingAddress.provinceCode,
            deliveryZip: shippingAddress.zip,
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    updateShippingAddress,
  };
};
